import React, { lazy } from 'react';
import { Gift, Sparkles, Tag } from 'lucide-react';
interface Bonus {
  id: number;
  title: string;
  img: string;
  price?: number;
}
const bonuses: Bonus[] = [{
  id: 1,
  title: 'MASTERCLASS PRO EDICIÓN EN CAPCUT',
  img: 'https://cdn.magicpatterns.com/uploads/tnsoHxvDkRbyiDSE7Z65RL/pasted-image.png',
  price: 24990
}, {
  id: 2,
  title: 'GUÍA PASO A PASO FÓRMULA CREADORA DE CONTENIDO UGC',
  img: 'https://cdn.magicpatterns.com/uploads/eFx4TxXr8GJV6Sjz2YkVjL/pasted-image.png',
  price: 24990
}, {
  id: 3,
  title: 'ACCESO A MI COMUNIDAD PRIVADA UGC EN WHATSAPP💘',
  img: 'https://cdn.magicpatterns.com/uploads/u99LPVskW27MrWr6AzKmMP/pasted-image.png',
  price: 23999
}, {
  id: 4,
  title: 'MIS PLANTILLAS Y RECURSOS EDITABLES',
  img: 'https://cdn.magicpatterns.com/uploads/3jcGT5YUZDacaSdycHPzGT/pasted-image.png',
  price: 18990
}, {
  id: 5,
  title: 'CERTIFICADO OFICIAL DE CREADORA UGC',
  img: 'https://cdn.magicpatterns.com/uploads/9Y4CDz1WeZhwYcPVji1pia/pasted-image.png'
}, {
  id: 6,
  title: 'CÓMO SER EMBAJADORA DE VIAJES IGUAL QUE YO',
  img: 'https://cdn.magicpatterns.com/uploads/hLJbaSgrKBzaThN7bhpsvy/pasted-image.png',
  price: 14990
}];
const formatARS = (n: number) => `$${n.toLocaleString('es-AR')} ARS`;
const totalSavings = bonuses.reduce((sum, b) => sum + (b.price ?? 0), 0);
export function BonusSection() {
  return <section className="px-6 py-8 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-30">
      {/* Eyebrow */}
      <div className="inline-flex items-center gap-2 bg-[#D4AF37]/15 border border-[#D4AF37]/40 text-[#9c7c12] font-bold text-[11px] md:text-sm uppercase tracking-[0.2em] px-5 py-2 rounded-full mb-6" data-id="element-31">
        <Gift size={15} strokeWidth={2.5} data-id="element-32" />
        Bonus exclusivos por tiempo limitado
      </div>

      <h2 className="font-serif font-bold text-3xl md:text-5xl text-brand-navy mb-12 leading-tight uppercase" data-id="element-33">
        ACCEDÉ AHORA Y LLEVATE <br data-id="element-34" /> 6 BONUS DE REGALO 💘
      </h2>

      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto" data-id="element-35">
        {bonuses.map(bonus => <div key={bonus.id} className="relative bg-white rounded-3xl p-[1.5px] bg-gradient-to-b from-[#D4AF37]/60 via-[#D98BAF]/30 to-transparent shadow-[0_18px_45px_-20px_rgba(31,31,46,0.4)] transition-transform duration-300 hover:-translate-y-1" data-id="element-36">
            {/* GRATIS ribbon */}
            <div className="absolute -top-3 right-5 z-20 bg-[#00c853] text-white font-black text-xs md:text-sm uppercase tracking-widest px-4 py-1.5 rounded-full shadow-[0_6px_18px_-4px_rgba(0,200,83,0.6)] flex items-center gap-1" data-id="element-37">
              <Sparkles size={13} strokeWidth={3} data-id="element-38" />
              Gratis
            </div>

            <div className="bg-white rounded-[1.4rem] p-6 pt-8 flex flex-col items-center h-full" data-id="element-39">
              <span className="text-[#D98BAF] font-serif font-black text-sm tracking-[0.25em] uppercase mb-3" data-id="element-40">
                Bonus #{bonus.id}
              </span>

              <h3 className="font-serif font-bold text-brand-navy text-lg md:text-xl mb-5 leading-tight uppercase min-h-[3.5rem] flex items-center" data-id="element-41">
                {bonus.title}
              </h3>

              <div className="flex-1 flex items-center justify-center w-full mb-6" data-id="element-42">
                {bonus.img ? <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className={`w-full h-auto drop-shadow-2xl ${bonus.id === 3 ? 'max-w-[200px]' : 'max-w-[270px]'}`} data-id="element-43" /> : <div className="w-full aspect-[3/4] bg-brand-lavenderLight/30 rounded-xl border-2 border-dashed border-brand-navy/10 flex items-center justify-center text-brand-navy/30 font-bold text-xs font-serif" data-id="element-44">
                    IMAGEN BONUS #{bonus.id}
                  </div>}
              </div>

              {/* Price row */}
              <div className="w-full pt-4 border-t border-black/5 flex flex-col items-center gap-1" data-id="element-45">
                {bonus.price ? <>
                    <span className="flex items-center gap-1.5 text-brand-navy/40 font-serif font-semibold text-lg line-through decoration-red-500/70 decoration-2" data-id="element-46">
                      <Tag size={15} className="text-brand-navy/30" data-id="element-47" />
                      {formatARS(bonus.price)}
                    </span>
                    <span className="text-[#00c853] font-serif font-black text-3xl tracking-tight" data-id="element-48">
                      HOY GRATIS
                    </span>
                  </> : <span className="text-[#00c853] font-serif font-black text-3xl tracking-tight py-2" data-id="element-49">
                    GRATIS
                  </span>}
              </div>
            </div>
          </div>)}
      </div>

      {/* Savings Summary */}
      <div className="mt-8 w-full max-w-3xl" data-id="element-50">
        <div className="relative rounded-[2.5rem] p-[2px] bg-gradient-to-r from-[#D4AF37] via-[#D98BAF] to-[#D4AF37] shadow-[0_25px_60px_-25px_rgba(217,139,175,0.6)]" data-id="element-51">
          <div className="bg-brand-navy rounded-[2.4rem] px-8 py-10 md:px-12 md:py-12 flex flex-col items-center text-center relative overflow-hidden" data-id="element-52">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-72 h-72 bg-[#D4AF37]/15 blur-[80px] rounded-full pointer-events-none" data-id="element-53" />

            <p className="relative text-brand-cream/80 font-serif text-lg md:text-2xl mb-2 tracking-wide" data-id="element-54">
              EN RESÚMEN... HOY TE LLEVÁS TODO ESTO 💘
            </p>
            <p className="relative text-white/60 font-medium text-sm md:text-base mb-6 uppercase tracking-widest" data-id="element-55">
              Valor real de los bonus
            </p>

            <p className="relative text-brand-cream/50 font-serif font-semibold text-2xl md:text-3xl line-through decoration-red-500/80 decoration-2 mb-3" data-id="element-56">
              {formatARS(totalSavings)}
            </p>

            <div className="relative inline-flex items-center gap-3 bg-[#00c853] text-white font-black text-xl md:text-3xl uppercase tracking-tight px-8 py-4 rounded-full shadow-[0_0_35px_rgba(0,200,83,0.45)] mb-6" data-id="element-57">
              <Sparkles size={26} strokeWidth={2.5} data-id="element-58" />
              Hoy te lo llevás GRATIS
            </div>

            <p className="relative text-white font-serif font-bold text-xl md:text-3xl leading-tight" data-id="element-59">
              Te ahorrás{' '}
              <span className="text-[#D4AF37] font-black drop-shadow-[0_0_15px_rgba(212,175,55,0.4)]" data-id="element-60">
                {formatARS(totalSavings)}
              </span>{' '}
              solo en bonus 🤯
            </p>
            <p className="relative text-brand-cream/70 font-serif text-base md:text-xl leading-snug italic mt-4 max-w-xl" data-id="element-61">
              ¡Por lo mismo que vas a ganar en tu primera collab paga!😱 Pero
              solo por el día de hoy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}